<av-card [popup]="true" vAlign="top">
  <!-- [@slideInOut]="true" // caused page to reload for some reason -->

  <av-card-header
    (close)="cancel()"
    subtitle="Please fill in the email address"
    translate
  >
    Customer's Email
  </av-card-header>
  <form #f="ngForm" (submit)="send(f.form)">
    <av-card-body>
      <av-control-row type="text">
        <input
          required
          placeholder="ex: customer@email.com"
          #formEmail="ngModel"
          name="address"
          [(ngModel)]="address"
          avInput
          email
          type="email"
          data-tid="conference/input-email-address"
        />
      </av-control-row>
      @if (formEmail.touched && formEmail.hasError('required')) {
      <div class="form-error" translate>Required</div>
      } @if (formEmail.touched && formEmail.hasError('email')) {
      <div class="form-error" translate>Invalid email</div>
      }
    </av-card-body>
    <av-card-footer>
      <button
        avButton
        type="submit"
        [loading]="isPosting()"
        [disabled]="isPosting()"
        size="block"
        color="accent"
        data-tid="conference/send-email"
        translate
      >
        Send Email
      </button>
    </av-card-footer>
  </form>
</av-card>
